import { Svg, SvgProps } from '@pancakeswap/uikit'

const LineChartLoaderSVG: React.FC<SvgProps> = (props) => {
  return (
    <Svg width="100%" height="100%" preserveAspectRatio="none" viewBox="0 0 100 50" {...props}>
      <path
        d="M 0 36 L 16 36 L 16.5 33.2 L 18 46 L 19.5 14 L 22 37 L 23.5 30 L 25 36 L 100 36 L 101 36"
        stroke="#D800FF"
        strokeWidth="0.2"
        strokeDasharray="180"
        strokeDashoffset="180"
        fill="transparent"
        opacity="0.7"
        /* filter="url(#glow)" */
      >
        <animate
          id="firstline"
          attributeName="stroke-dashoffset"
          dur="1.5s"
          from="180"
          to="-180"
          begin="1.5s;firstline.end+2s;"
        />
      </path>
      <path
        d="M 0 42 L 76 42 L 76.5 39.2 L 78 46 L 79.7 20 L 82 43 L 83.5 36 L 85 42 L 100 42 L 101 42"
        stroke="#D800FF"
        strokeWidth="0.2"
        strokeDasharray="180"
        strokeDashoffset="180"
        fill="transparent"
        opacity="0.3"
        /* filter="url(#glow)" */
      >
        <animate attributeName="stroke-dashoffset" dur="1.5s" from="180" to="-180" begin="2s;firstline.end+2.5s;" />
      </path>
      <path
        d="M 0 36 L 76 36 L 76.5 33.2 L 78 46 L 79.7 14 L 82 37 L 83.5 30 L 85 36 L 100 36 L 101 36"
        stroke="#D800FF"
        strokeWidth="0.2"
        strokeDasharray="180"
        strokeDashoffset="180"
        fill="transparent"
        opacity="0.7"
        /* filter="url(#glow)" */
      >
        <animate
          id="secondline"
          attributeName="stroke-dashoffset"
          dur="1.5s"
          from="180"
          to="-180"
          begin="0s;secondline.end+2s;"
        />
      </path>
      <path
        d="M 0 42 L 16 42 L 16.5 39.2 L 18 46 L 19.5 20 L 22 43 L 23.5 36 L 25 42 L 100 42 L 101 42"
        stroke="#D800FF"
        strokeWidth="0.2"
        strokeDasharray="180"
        strokeDashoffset="180"
        fill="transparent"
        opacity="0.3"
        /* filter="url(#glow)" */
      >
        <animate attributeName="stroke-dashoffset" dur="1.5s" from="180" to="-180" begin="0.5s;secondline.end+1.5s;" />
      </path>
      <defs>
        <filter id="glow">
          <feGaussianBlur className="blur" result="coloredBlur" stdDeviation="12" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
    </Svg>
  )
}

export default LineChartLoaderSVG
